import React from "react";
import { graphql, useFragment } from "react-relay";
import { AHText, Box, useTheme, AHIcon } from "arkh";
import { DateTime } from "luxon";
import { useIntlFormattedMonthDay } from "../useIntlFormattedMonthDay";
import { TeamScheduleListItemMonthlyRange_routineOccasion$key } from "./__generated__/TeamScheduleListItemMonthlyRange_routineOccasion.graphql";

export function TeamScheduleListItemMonthlyRange(props: {
  routineOccasion: TeamScheduleListItemMonthlyRange_routineOccasion$key;
}) {
  const routineOccasion = useFragment(
    graphql`
      fragment TeamScheduleListItemMonthlyRange_routineOccasion on ScheduledOccasion {
        startAt
        deadlineAt
      }
    `,
    props.routineOccasion
  );

  const startDay = DateTime.fromISO(routineOccasion.startAt).day;
  const endDay = routineOccasion.deadlineAt
    ? DateTime.fromISO(routineOccasion.deadlineAt).minus({
        minute: 1,
      }).day
    : null;

  return (
    <TeamScheduleListItemMonthlyRangeComponent
      startDay={startDay}
      endDay={endDay}
    />
  );
}

export function TeamScheduleListItemMonthlyRangeComponent({
  startDay,
  endDay,
}: {
  startDay: number | null;
  endDay: number | null;
}) {
  const theme = useTheme();
  const ordinalFormatter = useIntlFormattedMonthDay("short");
  return (
    <Box
      style={{ flexDirection: "row", alignItems: "center" }}
      spaceBottom="xxsmall"
    >
      {startDay ? (
        <AHText color="text-washed" type="info-small">
          {ordinalFormatter(startDay)}
        </AHText>
      ) : null}
      {endDay ? (
        <>
          <Box spaceHorizontal="xxsmall">
            <AHIcon type="arrow-right" forceSize={12} customColor={theme["text-washed"]} />
          </Box>
          <AHText color="text-washed" type="info-small">
            {ordinalFormatter(endDay)}
          </AHText>
        </>
      ) : null}
    </Box>
  );
}
